import request from 'utils/request'
export const getBusinessList = () => request().get('business/jsonList')
/**
 * 获取 大区 | 业务模式 | 信控区列表
 */
export const getRegionList = data =>
  request().post('business/region/list', data)
// 业务类型
export const getSearchBusinessList = () =>
  request().post('warning/business/list')
/**
 * 业务模式
 */
export const getSearchRegionList = businessId =>
  request().post(`warning/model/list/${businessId}`)

//   getPage
export const getPage = data => request().post('warning/page', data)
// 添加或者修改
export const add = data => request().post('warning/addOrUpdate', data)
// 删除
export const remove = id => request().get(`warning/delete/${id}`)

// 获取业务类型列表
export const getFreezeBgList = () =>
  request().get('business/jsonList/getFreezeBgList')

// 获取业务模式冻结列表
export const getFreezeModelList = () =>
  request().get('business/jsonList/getFreezeModelList')
